import { Dayjs } from 'dayjs';
import TimeSlotsPickerSkeleton from './TimeSlotsPickerSkeleton';
import { TimeslotsByDate } from '@/lib/react-query/Queries/gCalendar/useGetMonthTimeSlots';
import { useTenantTheme } from '@/lib/hooks/useTenantTheme';

type Props = {
  monthTimeSlots: TimeslotsByDate | null;
  date: Dayjs | null;
  selectedSlot: string | null;
  onChange?: (timeSlot: string) => void;
  loading?: boolean;
  disabled?: boolean;
};

const TimeSlotsPicker = ({
  monthTimeSlots,
  date,
  selectedSlot,
  onChange,
  loading = false,
  disabled = false,
}: Props) => {
  const accentColor = useTenantTheme().primary[800];
  return (
    <div className="grid grid-cols-3 gap-[12px] overflow-y-auto h-full place-content-around">
      {loading && <TimeSlotsPickerSkeleton />}
      {monthTimeSlots &&
        !loading &&
        date &&
        monthTimeSlots[date.format('YYYY-MM-DD')]?.map((slot) => {
          const isSelected = selectedSlot === slot.displayTime;

          return (
            <div
              key={slot.from}
              onClick={() => onChange && onChange(slot.displayTime)}
              className={`rounded-md text-center text-[14px] font-medium h-[55px] flex flex-col justify-center border-[1px] cursor-pointer 
          ${!isSelected ? 'border-[#DBDCDF]' : ''} ${
                disabled ? 'pointer-events-none' : ''
              }`}
              style={
                isSelected
                  ? {
                      color: accentColor,
                      borderColor: accentColor,
                    }
                  : undefined
              }
            >
              {slot.displayTime}
              {slot.displayMessage && (
                <>
                  <br />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: slot.displayMessage,
                    }}
                    className={`text-[10px] ${
                      !isSelected ? 'text-[#575B63]' : ''
                    }`}
                    style={
                      isSelected
                        ? {
                            color: accentColor,
                          }
                        : undefined
                    }
                  />
                </>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default TimeSlotsPicker;
